import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Box, CloseIcon, Description, Link, Title, Emoji } from './StyledAnnouncement';

class Announcement extends Component {
  componentDidMount() {
    /* eslint-env browser */
    this.metricsLib = window.metricsLib;
  }

  clickHandler = () => {
    const { onClick, id, subject, source } = this.props;
    onClick(id);
    if (this.metricsLib) {
      this.metricsLib.track(`${source}:sliding-popup:clicking-cta`, {
        trackData: `${id}:${subject}`
      });
    }
  };

  closeHandler = () => {
    const { onClose, id, subject, source } = this.props;
    onClose(id);
    if (this.metricsLib) {
      this.metricsLib.track(`${source}:sliding-popup:close`, { trackData: `${id}:${subject}` });
    }
  };

  renderEmoji = (emoji, index) => (
    <Emoji key={index} aria-label="icon" role="img">
      {emoji}
    </Emoji>
  );
  render() {
    const { subject, description, link, cta, emojis } = this.props;
    return (
      <Box>
        <CloseIcon aria-label="Close" onClick={this.closeHandler} type="button" />
        <Title>
          {emojis.map(this.renderEmoji)}
          {subject}
        </Title>
        <Description>{description}</Description>
        <Link onClick={this.clickHandler} target="_blank" href={link}>
          {cta}
        </Link>
      </Box>
    );
  }
}

Announcement.defaultProps = {
  emojis: []
};

Announcement.propTypes = {
  id: PropTypes.string.isRequired,
  subject: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  cta: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
  source: PropTypes.string.isRequired,
  emojis: PropTypes.arrayOf(PropTypes.string)
};

export default Announcement;



// WEBPACK FOOTER //
// ./src/components/Announcement/Announcement.js